import axios from 'axios'

const brasil_api = axios.create({
    baseURL: 'https://brasilapi.com.br/api'
})

export default brasil_api
